export const BUTTON_PRESS = 'Button Press:'
export const TAB_PRESS = 'Tab Press:'
export const RIGHT_CLICK = 'Right Click:'
export const VIEW = 'View:'
export const PAGE_LOAD = 'Page Load:'
export const TOGGLE = 'Toggle:'
export const SCROLL = 'Infinite scrolling:'
export const UP = 'Up'
export const DOWN = 'Down'
